import React, { useEffect, useState, useContext } from 'react';
import { getEgsTGarbageEdiInvoiceItem, getEgsTGarbageEdiInvoiceData, getEgsTGarbageEdiInvoiceDetail, getEgsTGarbageEdiEmissionsData } from '../../lib/api/egs_t_garbage_edi';
import { getEgsMTraderUser }  from '../../lib/api/egs_m_trader';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import SpaceRow from '../commons/SpaceRow';
import {
  Button,
  TextField,
  Box,
  Grid,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@material-ui/core';
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarExport,
  jaJP
} from '@mui/x-data-grid-pro'
import { AuthContext } from '../../App';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  fontWeight: {
    fontWeight: 900,
  },
  root: {
    '& > *': {
      margin: theme.spacing(1),
      width: '100ch',
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  container: {
    borderWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    marginBottom: 8,
    width: "85vw",
    margin: "auto",
  },
  container2: {
    borderWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    marginBottom: 8,
    width: "1000px",
    margin: "auto",
  },
  row: {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "#CCC",
  },
  title_box: {
    background: "#EEE",
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "#CCC",
    borderStyle: "solid",
    height: "100%",
  },
  value_box: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderStyle: "solid",
    borderColor: "#CCC",
  },
  printHide: {
    '@media print': {
      display: 'none',
    },
  },
}));

const EmissionsCount = () => {
  const { currentUser } = useContext(AuthContext);
  const [selectedJwnetNo, setSelectedJwnetNo] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedExhaustName, setSelectedExhaustName] = useState('');
  const [showFiscalYear, setShowFiscalYear] = useState(false); // 年度表示の状態を管理

  const classes = useStyles();

  // 月の配列を定義
  const months = Array.from({length: 12}, (_, i) => {
    const date = new Date(2024, 3 + i, 1);
    return date.toLocaleString('ja-JP', { month: 'long' });
  });

  // 年度の開始日と終了日を計算する関数
  const getFiscalYearDates = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentYear = today.getFullYear();
    
    // 4月以降は当年の4月1日～翌年3月31日
    // 3月以前は前年の4月1日～当年3月31日
    let startYear, endYear;
    if (currentMonth >= 4) {
      startYear = currentYear;
      endYear = currentYear + 1;
    } else {
      startYear = currentYear - 1;
      endYear = currentYear;
    }

    const startDate = new Date(startYear, 3, 1); // 4月1日
    const endDate = new Date(endYear, 2, 31); // 3月31日

    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    return {
      start: formatDate(startDate),
      end: formatDate(endDate)
    };
  };

  const { start: defaultStart, end: defaultEnd } = getFiscalYearDates();

  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFilterChanged, setIsFilterChanged] = useState(false);
  const [filter, setFilter] = useState({
    sect1TransportName: '',
    searchDateStart: defaultStart,
    searchDateEnd: defaultEnd,
    exhaustName: '',
    wasteName: '',
    invoiceDateType: '0'
  });

  const [detailData, setDetailData] = useState([]);
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  const [invoiceDetailData, setInvoiceDetailData] = useState([]);
  const [isInvoiceDetailLoading, setIsInvoiceDetailLoading] = useState(false);

  const [detailOpen1, setDetailOpen1] = useState(false);
  const handleOpen1 = () => {
    setDetailOpen1(true);
  };

  const [selectedMonthData, setSelectedMonthData] = useState(null);
  const [monthlyDetailData, setMonthlyDetailData] = useState([]);
  const [isMonthlyDetailLoading, setIsMonthlyDetailLoading] = useState(false);

  const [selectedCell, setSelectedCell] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);

  const [selectedSummaryRow, setSelectedSummaryRow] = useState(null);

  useEffect(() => {
    if (currentUser.traderKbn === '1000000000') {
      // console.log("traderKbn",currentUser.traderKbn)
      // console.log("searchDateStart",filter.searchDateStart)
      // console.log("searchDateEnd",filter.searchDateEnd)
      // console.log("traderName",currentUser.nickname)
      // console.log("wasteName",filter.wasteName)
      // console.log("invoiceDateType",filter.invoiceDateType)
      // 排出事業者の場合、traderNameをexhaustN
      // 排出事業者の場合、traderNameをexhaustNameとして設定
      setSelectedExhaustName(currentUser.nickname);
      // 排出事業者のデータを直接取得
      const emissionsdataparams = `_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}__${currentUser.nickname}_${filter.wasteName}_${filter.invoiceDateType}`;
      setIsDetailLoading(true);
      getEgsTGarbageEdiEmissionsData(emissionsdataparams)
        .then(res => {
          const dataWithId = res.data.map((item, index) => ({
            id: index,
            ...item
          }));
          // console.log("dataWithId",dataWithId)
          setDetailData(dataWithId);
        })
        .catch(error => {
          console.error('Error fetching emissions data:', error);
        })
        .finally(() => {
          setIsDetailLoading(false);
        });
    } else {
      handleGetList();
    }
  }, []);

  const handleGetList = async (params) => {
    try {
      setIsLoading(true);
      let traderCd = currentUser.traderCd;
      
      // currentUser.traderKbnが'1111111111'の場合、traderCdをNullに設定
      if (currentUser.traderKbn === '1111111111' || currentUser.traderKbn === '0000000001') {
        traderCd = '';
      }
      
      const defaultParams = `${traderCd}_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}_${filter.sect1TransportName}_${filter.exhaustName}_${filter.wasteName}_${filter.wasteName}_${filter.invoiceDateType}`;
      const res = await getEgsTGarbageEdiInvoiceItem(params || defaultParams);
      const dataWithId = res.data.map((item, index) => ({
        id: index,
        ...item
      }));

      // currentUser.traderKbn === '0000000001'の場合、groupCd1 === currentUser.traderCdのデータのみをフィルタリング
      if (currentUser.traderKbn === '0000000001') {
        const filteredDataList = dataWithId.filter(item => item.groupCd1 === currentUser.traderCd);
        setDataList(filteredDataList);
      } else {
        setDataList(dataWithId);
      }
      
      setIsFilterChanged(false);
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setIsFilterChanged(true);
  };

  const startFilter = () => {
    setDetailData([]);
    setInvoiceDetailData([]);
    setSelectedExhaustName(''); // 排出事業者名をリセット
    setSelectedMonthData(null); // 月の詳細データをクリア
    setMonthlyDetailData([]); // 月の詳細データをクリア

    if (currentUser.traderKbn === '1000000000') {
      // 排出事業者の場合、nicknameをexhaustNameとして設定
      setSelectedExhaustName(currentUser.nickname);
      // 排出事業者のデータを直接取得
      const emissionsdataparams = `_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}__${currentUser.nickname}_${filter.wasteName}_${filter.invoiceDateType}`;
      setIsDetailLoading(true);
      getEgsTGarbageEdiEmissionsData(emissionsdataparams)
        .then(res => {
          const dataWithId = res.data.map((item, index) => ({
            id: index,
            ...item
          }));
          setDetailData(dataWithId);
        })
        .catch(error => {
          console.error('Error fetching emissions data:', error);
        })
        .finally(() => {
          setIsDetailLoading(false);
          setIsFilterChanged(false); // データ表示後にボタンを非活性化
        });
    } else {
      let traderCd = currentUser.traderCd;
      if (currentUser.traderKbn === '1111111111' || currentUser.traderKbn === '0000000001') {
        traderCd = '';
      }
      
      const params = `${traderCd}_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}_${filter.sect1TransportName}_${filter.exhaustName}_${filter.wasteName}_${filter.invoiceDateType}`;
      handleGetList(params);
      setIsFilterChanged(false); // データ表示後にボタンを非活性化
    }
    setShowFiscalYear(true); // データ表示時に表示する
  };

  // 年度を移動する関数
  const moveFiscalYear = (direction) => {
    const currentStart = new Date(filter.searchDateStart);
    const currentEnd = new Date(filter.searchDateEnd);
    
    if (direction === 'prev') {
      currentStart.setFullYear(currentStart.getFullYear() - 1);
      currentEnd.setFullYear(currentEnd.getFullYear() - 1);
    } else {
      currentStart.setFullYear(currentStart.getFullYear() + 1);
      currentEnd.setFullYear(currentEnd.getFullYear() + 1);
    }

    setFilter({
      ...filter,
      searchDateStart: currentStart.toISOString().split('T')[0],
      searchDateEnd: currentEnd.toISOString().split('T')[0],
    });
    setIsFilterChanged(true); // 年度変更時にボタンを活性化
    setShowFiscalYear(false); // 年度変更時に非表示にする
    setDetailData([]); // 廃棄物別月別排出量集計のデータをクリア
    setDataList([]); // 排出事業者名のデータをクリア
    setSelectedMonthData(null); // 月の詳細データをクリア
    setMonthlyDetailData([]); // 月の詳細データをクリア
  };

  // 集計対象日が変更された時の処理
  const handleInvoiceDateTypeChange = (e) => {
    handleFilterChange({ ...filter, invoiceDateType: e.target.value });
    setDetailData([]); // 廃棄物別月別排出量集計のデータをクリア
    setDataList([]); // 排出事業者名のデータをクリア
  };

  // 前年度に移動
  const moveToPrevFiscalYear = () => {
    moveFiscalYear('prev');
  };

  // 次年度に移動
  const moveToNextFiscalYear = () => {
    moveFiscalYear('next');
  };

  // 合計を計算する関数
  const calculateTotals = () => {
    return dataList.reduce((acc, curr) => {
      return {
        kensu: acc.kensu + (curr.kensu || 0),
        torikesi: acc.torikesi + (curr.torikesi || 0),
        touroku: acc.touroku + (curr.touroku || 0),
      };
    }, { kensu: 0, torikesi: 0, touroku: 0 });
  };

  const handleRowClick = async (params) => {
    const invoicedataparams = `${params.row.sect1TransportCd}_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}_${filter.sect1TransportName}_${params.row.exhaustName}_${filter.wasteName}_${filter.invoiceDateType}`;
    // console.log("params",params);
    setIsDetailLoading(true);
    // 最下段の DataGridPro を初期化
    setInvoiceDetailData([]);
    // jwnetNoを保存
    setSelectedJwnetNo(params.row.jwnetNo);
    try {
      const res = await getEgsTGarbageEdiInvoiceData(invoicedataparams);
      const dataWithId = res.data.map((item, index) => ({
        id: index,
        ...item
      }));
      setDetailData(dataWithId);
    } catch (error) {
      console.error('Error fetching detail data:', error);
    } finally {
      setIsDetailLoading(false);
    }
  };

  const handleExhaustRowClick = async (params) => {
    const emissionsdataparams = `_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}__${params.row.exhaustName}_${filter.wasteName}_${filter.invoiceDateType}`;
    setIsDetailLoading(true);
    setInvoiceDetailData([]);
    setSelectedJwnetNo(params.row.jwnetNo);
    setSelectedExhaustName(params.row.exhaustName);
    // 月の詳細データをクリア
    setSelectedMonthData(null);
    setMonthlyDetailData([]);
    try {
      const res = await getEgsTGarbageEdiEmissionsData(emissionsdataparams);
      const dataWithId = res.data.map((item, index) => ({
        id: index,
        ...item
      }));
      setDetailData(dataWithId);
    } catch (error) {
      console.error('Error fetching detail data:', error);
    } finally {
      setIsDetailLoading(false);
    }
  };

  const handleDetailRowClick = async (params) => {
    const invoicedetailparams = `${params.row.sect1TransportCd}_${currentUser.traderKbn}_${filter.searchDateStart}_${filter.searchDateEnd}_${filter.sect1TransportName}_${params.row.exhaustName}_${params.row.wasteName}_${filter.invoiceDateType}_${params.row.packingName}`;
    // console.log("invoicedetailparams",invoicedetailparams);
    setIsInvoiceDetailLoading(true);
    try {
      const res = await getEgsTGarbageEdiInvoiceDetail(invoicedetailparams);
      const dataWithId = res.data.map((item, index) => ({
        id: index,
        ...item
      }));
      setInvoiceDetailData(dataWithId);
    } catch (error) {
      console.error('Error fetching invoice detail data:', error);
    } finally {
      setIsInvoiceDetailLoading(false);
    }
  };

  const handleadminRowClick = async (params) => {
    const selectedSect1TransportCd = params.row.sect1TransportCd; // 選択したレコードのsect1TransportCdを取得
    setSelectedSummaryRow(params.row); // 選択された行を保存
    // 最下段の DataGridPro を初期化
    setDetailData([]);
    // sect1TransportCdが一致するレコードのみをフィルタリング
    const filteredData = dataList.filter(item => item.sect1TransportCd === selectedSect1TransportCd);  
    setDataList(filteredData); // フィルタリングされたデータを設定
  };
    // 日付のみをフォーマットする関数
    const formatDateOnly = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().split('T')[0]; // 'YYYY-MM-DD' 形式で返す
    };

    // 集計データの状態を更新
    const [summaryData, setSummaryData] = useState([]);

    // 集計データ用のカラム定義
    const summaryColumns = [
      { field: 'sect1TransportCd', headerName: '収集運搬事業者CD', width: 150 },
      { field: 'name', headerName: '事業場名', width: 400 },
      { field: 'total', headerName: '合計発行件数', type: 'number', width: 150 },
      { field: 'A', headerName: '料金区分A', type: 'number', width: 150 },
      { field: 'B', headerName: '料金区分B', type: 'number', width: 150 },
      { field: 'C', headerName: '料金区分C', type: 'number', width: 150 },
      ...(currentUser.traderKbn === '1111111111' ? [{
        field: 'chargeDivision', 
        headerName: '料金単価（円/件）', 
        width: 150,
        type: 'number',
        valueGetter: (params) => {
          return Number(params.row.chargeDivision) || 0;
        },
        headerAlign: 'right',
        align: 'right',
      }] : []),
    ];
  
    // データリストが更新されたときに集計を行う
    useEffect(() => {
      const fetchTraderUser = async (traderCd) => {
        return await getEgsMTraderUser(traderCd);
      };

      const updateSummaryWithchargeDivision = async (summary) => {
        for (const key in summary) {
          const traderUser = await getEgsMTraderUser(summary[key].sect1TransportCd);
          summary[key].chargeDivision = traderUser.data[0].chargeDivision; // chargeDivisionを追加
          summary[key].groupCd1 = traderUser.data[0].groupCd1; // group_cd1を追加
          // console.log("sect1TransportCd",summary[key].sect1TransportCd)
          // console.log("traderUser.data[0].chargeDivision",traderUser.data[0].chargeDivision)
        }
        return summary;
      };

      const fetchData = async () => { // 非同期関数を定義
      if (currentUser.traderKbn === '1111111111' || currentUser.traderKbn === '0000000001') {
        const summary = {};
    
        dataList.forEach(item => {
          if (!summary[item.sect1TransportName]) {
            summary[item.sect1TransportName] = { 
              name: item.sect1TransportName, 
              sect1TransportCd: item.sect1TransportCd, // sect1TransportCdを追加
              total: 0, 
              A: 0, 
              B: 0, 
              C: 0 
            };
          }
    
          summary[item.sect1TransportName].total += item.kensu;
    
          switch (item.chargeDivision) {
            case '1':
              summary[item.sect1TransportName].A += item.kensu;
              break;
            case '2':
              summary[item.sect1TransportName].B += item.kensu;
              break;
            case '3':
              summary[item.sect1TransportName].C += item.kensu;
              break;
          }
        });
    
        // zipを取得してsummaryを更新
        const updatedSummary = await updateSummaryWithchargeDivision(summary);
        
        // traderKbn === '0000000001'の場合、group_cd1='002'のデータのみをフィルタリング
        let filteredSummary = updatedSummary;
        if (currentUser.traderKbn === '0000000001') {
          filteredSummary = Object.fromEntries(
            Object.entries(updatedSummary).filter(([_, value]) => value.groupCd1 === currentUser.traderCd)
          );
        }
        
        setSummaryData(Object.values(filteredSummary).map((item, index) => ({ id: index, ...item })));
        console.log("summaryData",summaryData)
      }
    };

    fetchData(); // 非同期関数を呼び出す
    }, [dataList, currentUser.traderKbn]);

  const cols = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'sect1TransportCd', headerName: '収集運搬事業者CD', width: 140 },
    { field: 'sect1TransportName', headerName: '収集運搬事業者名', width: 300 },
    { field: 'jwnetNo', headerName: 'JWNET加入者番号', width: 140 },
    { field: 'exhaustCd', headerName: '排出事業者CD', width: 140 },
    { field: 'exhaustName', headerName: '排出事業者', width: 400 },
    { 
      field: 'chargeDivision', 
      headerName: 'JWNET料金区分', 
      width: 150,
      valueGetter: (params) => {
        switch (params.value) {
          case '1':
            return 'A';
          case '2':
            return 'B';
          case '3':
            return 'C';
          default:
            return params.value;
        }
      }
    },
    { field: 'kensu', headerName: 'マニフェスト発行件数', width: 200 },
    { field: 'torikesi', headerName: 'マニフェスト取消件数', width: 200 },
    { field: 'touroku', headerName: 'マニフェスト登録件数', width: 200 },
  ];

  const detailColumns = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'sect1TransportCd', headerName: '収集運搬事業者CD', width: 140 },
    { field: 'sect1TransportName', headerName: '収集運搬事業者名', width: 300 },
    { field: 'exhaustName', headerName: '排出事業者', width: 400 },
    { field: 'kensu', headerName: 'マニフェスト登録件数', width: 200 },
    { field: 'wasteName', headerName: '廃棄物名称', width: 200 },
    { field: 'vol', headerName: '数量', width: 100 },
    { field: 'unitName', headerName: '単位', width: 200 },
    { 
      field: 'packingvol', 
      headerName: '荷姿数量', 
      width: 100,
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        // 値を整数に変換して表示
        return Math.round(params.value).toString();
      }
    },
    { field: 'packingName', headerName: '荷姿単位', width: 200 },
  ];

  const invoiceDetailColumns = [
    {
      field: 'recordNo',
      headerName: 'No.',
      width: 40,
      valueGetter: (params) => params.api.getRowIndex(params.id) + 1,
    },
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'sect1TransportChargeName', headerName: '収集担当者', width: 120 },
    { 
      field: currentUser.traderKbn === '1000000000' ? 'sect1TransportName' : 'exhaustName', 
      headerName: currentUser.traderKbn === '1000000000' ? '収集運搬事業者' : '排出事業者', 
      width: 200 
    },
    { field: 'exhaustDate', headerName: '排出日', width: 100 },
    { field: 'manifestNo', headerName: 'マニフェスト番号', width: 140 },
    { field: 'wasteName', headerName: '廃棄物名称', width: 200 },
    { 
      field: 'amount1', 
      headerName: '数量', 
      width: 80,
      headerAlign: 'right',
      align: 'right'
    },
    { field: 'unitName', headerName: '単位', width: 100 },
    { 
      field: 'packingAmount1', 
      headerName: '荷姿数量', 
      width: 80,
      headerAlign: 'right',
      align: 'right'
    },
    { field: 'packingName', headerName: '荷姿単位', width: 140 },
    { field: 'memo1', headerName: '備考１', width: 120 },
    { field: 'memo2', headerName: '備考２', width: 80 },
    { field: 'memo3', headerName: '備考３', width: 60 },
    { field: 'memo4', headerName: '備考４', width: 60 },
    { field: 'memo5', headerName: '備考５', width: 60 },
    { field: 'lastProcessingTraderName', headerName: '最終処分場', width: 200 },
    { field: 'createdAt', 
      headerName: '作成日', 
      width: 100,
      valueFormatter: (params) => formatDateOnly(params.value)
    },
    { field: 'middleEnd', headerName: '中間処理日', width: 100 },
    { field: 'lastProcessingEnd', headerName: '最終処分日', width: 100 },
  ];
  
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
      <GridToolbarExport
        csvOptions={{
          fileName: 'Sdgs12_InvoiceData',
          delimiter: ',',
          utf8WithBom: true,
        }}
      />
      </GridToolbarContainer>
    )
  }

  const handleOpenEditDialog = () => {
    setOpenEditDialog(true); // モーダルを開く
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false); // モーダルを閉じる
  };

  const processWasteData = (data) => {
    const wasteTypes = [...new Set(data.map(item => item.wasteName))];
    const processedData = wasteTypes.map(wasteType => {
      const monthData = data.find(item => item.wasteName === wasteType);
      const unit = monthData?.unitName || '';

      const monthlyData = months.map((month, index) => {
        const monthData = data.filter(item => 
          item.wasteName === wasteType && 
          new Date(item['']).getMonth() === (3 + index) % 12
        );
        return {
          volume: monthData.reduce((sum, item) => sum + parseFloat(item.vol), 0)
        };
      });

      // 合計値を計算
      const total = monthlyData.reduce((sum, data) => sum + data.volume, 0);

      // DataGrid用の行データを作成
      const rowData = {
        id: wasteType,
        wasteType,
        unit,
        ...months.reduce((acc, month, index) => {
          acc[month] = monthlyData[index].volume.toFixed(1);
          return acc;
        }, {}),
        total: total.toFixed(1)
      };

      return rowData;
    });

    return processedData;
  };

  const handleMonthClick = async (params) => {
    if (!params.field || params.field === 'wasteType' || params.field === 'unit' || params.field === 'total') {
      return;
    }

    setSelectedCell({ rowId: params.id, field: params.field });
    const wasteType = params.row.wasteType;
    const month = params.field;
    const selectedData = detailData.find(item => 
      item.wasteName === wasteType && 
      new Date(item['']).getMonth() === (3 + months.indexOf(month)) % 12
    );

    // データが無いまたは０の場合は詳細をクリア
    if (!selectedData || parseFloat(params.value) === 0) {
      setSelectedMonthData(null);
      setMonthlyDetailData([]);
      return;
    }

    if (selectedData) {
      setSelectedMonthData({ wasteType, month, data: selectedData });
      setIsMonthlyDetailLoading(true);
      try {
        // 選択された月の1日と最終日を計算
        const startYear = new Date(filter.searchDateStart).getFullYear();
        const endYear = new Date(filter.searchDateEnd).getFullYear();
        const monthIndex = months.indexOf(month);
        
        // 1月～3月の場合は翌年、それ以外は当年として扱う
        const year = monthIndex >= 9 ? startYear + 1 : startYear;
        
        const adjustedMonthIndex = (monthIndex + 3) % 12;
        
        const startDate = new Date(year, adjustedMonthIndex, 1);
        const endDate = new Date(year, adjustedMonthIndex + 1, 0);
        
        // 日付をYYYY-MM-DD形式にフォーマット
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
 
          return `${year}-${month}-${day}`;
        };

        const monthStart = formatDate(startDate);
        const monthEnd = formatDate(endDate);

        // wasteNameからpH値を削除
        const cleanWasteName = selectedData.wasteName.replace(/pH\d+\.\d+/, '').trim();

        const invoicedetailparams = `_${currentUser.traderKbn}_${monthStart}_${monthEnd}__${selectedData.exhaustName}_${cleanWasteName}_${filter.invoiceDateType}_`;
        // console.log("setMonthlyDetailData_invoicedetailparams", invoicedetailparams);
        const res = await getEgsTGarbageEdiInvoiceDetail(invoicedetailparams);
        const dataWithId = res.data.map((item, index) => ({
          id: index,
          ...item
        }));
        // console.log("setMonthlyDetailData_dataWithId", dataWithId);
        setMonthlyDetailData(dataWithId);
      } catch (error) {
        console.error('Error fetching monthly detail data:', error);
      } finally {
        setIsMonthlyDetailLoading(false);
      }
    }
  };

  const WasteMonthlyGrid = ({ data, selectedExhaustName }) => {
    const processedData = processWasteData(data);

    // 年度の表示形式を取得
    const getFiscalYearDisplay = () => {
      const startYear = new Date(filter.searchDateStart).getFullYear();
      const endYear = new Date(filter.searchDateEnd).getFullYear();
      return `${startYear}年4月～${endYear}年3月`;
    };

    const columns = [
      { 
        field: 'wasteType', 
        headerName: '廃棄物名', 
        width: 260,
        headerAlign: 'center',
        align: 'left'
      },
      ...months.map(month => ({
        field: month,
        headerName: month,
        width: 130,
        headerAlign: 'center',
        align: 'right',
        valueFormatter: (params) => {
          return params.value ? `${params.value}` : '0.0';
        }
      })),
      {
        field: 'total',
        headerName: '合計',
        width: 130,
        headerAlign: 'center',
        align: 'right',
        valueFormatter: (params) => {
          return params.value ? `${params.value}` : '0.0';
        }
      },
      { 
        field: 'unit', 
        headerName: '単位', 
        width: 130,
        headerAlign: 'center',
        align: 'center'
      }
    ];

    return (
      <div style={{ marginTop: '20px', width: '100%' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '10px'
        }}>
          <h2>
            廃棄物別月別排出量集計
            {showFiscalYear && `　表示対象：${getFiscalYearDisplay()}`}
            {selectedExhaustName && `　　排出事業者：${selectedExhaustName}`}
          </h2>
        </div>
        <div className={classes.container}>
          <Box sx={{ height: 412, width: '100%' }}>
            <DataGridPro
              sx={{
                ...styles.grid2,
                '& .MuiDataGrid-cell': {
                  '&.selected': {
                    backgroundColor: '#e3f2fd !important',
                    '&:hover': {
                      backgroundColor: '#bbdefb !important',
                    },
                  },
                },
              }}
              rows={processedData}
              columns={columns}
              density="compact"
              components={{
                Toolbar: CustomToolbar,
              }}
              showColumnRightBorder
              showCellRightBorder
              localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
              onCellClick={handleMonthClick}
              getCellClassName={(params) => {
                if (selectedCell && params.id === selectedCell.rowId && params.field === selectedCell.field) {
                  return 'selected';
                }
                return '';
              }}
            />
          </Box>
        </div>
        {selectedMonthData && (
          <div style={{ marginTop: '20px' }}>
            <h3>
              {selectedMonthData.wasteType} - {selectedMonthData.month}の詳細
            </h3>
            <div className={classes.container}>
              <Box sx={{ height: 500, width: '100%' }}>
                <DataGridPro
                  sx={styles.grid3}
                  columns={invoiceDetailColumns}
                  rows={monthlyDetailData}
                  loading={isMonthlyDetailLoading}
                  density="compact"
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  showColumnRightBorder
                  showCellRightBorder
                  localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                />
              </Box>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <h1>排出量集計（{new Date().toLocaleString()})　　　
        <Button
          onClick={() => window.location.reload()}
          color="primary"
          style={{ marginLeft: '20px' }}
        >
          最新（再読み込み）
        </Button>
      </h1>
      {currentUser.traderKbn === '1000000000' ? (
        <>
          <Grid container spacing={2}>
            <Grid item xs style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}>
              <Box p={1} display={"flex"} alignItems={"center"}>
                <Typography variant="h6" style={{ fontWeight: 700 }}>集計年度：</Typography>
              </Box>
              <Button onClick={moveToPrevFiscalYear} style={{ marginLeft: 8 }}>◀</Button>
              <TextField
                value={filter.searchDateStart}
                onChange={e => handleFilterChange({ ...filter, searchDateStart: e.target.value })}
                type="date"
                InputLabelProps={{ shrink: true }}
                disabled
                InputProps={{
                  style: { color: '#000000' }
                }}
              />
              <div style={{ marginLeft: 16, marginRight: 16 }}> ～ </div>
              <TextField
                value={filter.searchDateEnd}
                onChange={e => handleFilterChange({ ...filter, searchDateEnd: e.target.value })}
                type="date"
                InputLabelProps={{ shrink: true }}
                disabled
                InputProps={{
                  style: { color: '#000000' }
                }}
              />
              <Button onClick={moveToNextFiscalYear} style={{ marginLeft: 8 }}>▶</Button>

              {/* <Typography variant="h6" style={{ fontWeight: 700, marginLeft: '16px' }}>　集計対象日：</Typography>
              <FormControl className={classes.formControl}>
                <Select
                  value={filter.invoiceDateType}
                  onChange={handleInvoiceDateTypeChange}
                  displayEmpty
                  className={classes.selectEmpty}
                >
                  <MenuItem value="0">排出日</MenuItem>
                  <MenuItem value="1">作成日</MenuItem>
                  <MenuItem value="2">中間処理日</MenuItem>
                  <MenuItem value="3">最終処分日</MenuItem>
                </Select>
              </FormControl> */}
              <Button
                variant='contained'
                color='primary'
                onClick={startFilter}
                style={{ marginLeft: 24 }}
                disabled={!isFilterChanged}
              >
                データ表示
              </Button>
            </Grid>
          </Grid>
          <SpaceRow height={10} />
          <WasteMonthlyGrid data={detailData} selectedExhaustName={selectedExhaustName} />
        </>
      ) : (
        <>
          <Grid container spacing={2}>
            <Grid item xs style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}>
              {/* 区間１運搬事業者の入力エリア（条件付きレンダリング） */}
              {currentUser.traderKbn === '1111111111' && (
                <>
                  <Typography variant="h7" style={{ fontWeight: 700 }}>　区間１運搬事業者：</Typography>
                  <TextField
                    value={filter.sect1TransportName}
                    onChange={e => handleFilterChange({ ...filter, sect1TransportName: e.target.value })}
                    onKeyDown={(e) => { if (e.key === 'Enter') startFilter(); }}
                  />
                </>
              )}
              <Box p={1} display={"flex"} alignItems={"center"}>
                <Typography variant="h6" style={{ fontWeight: 700 }}>集計年度：</Typography>
              </Box>
              <Button onClick={moveToPrevFiscalYear} style={{ marginLeft: 8 }}>◀</Button>
              <TextField
                value={filter.searchDateStart}
                onChange={e => handleFilterChange({ ...filter, searchDateStart: e.target.value })}
                type="date"
                InputLabelProps={{ shrink: true }}
                disabled
                InputProps={{
                  style: { color: '#000000' }
                }}
              />
              <div style={{ marginLeft: 16, marginRight: 16 }}> ～ </div>
              <TextField
                value={filter.searchDateEnd}
                onChange={e => handleFilterChange({ ...filter, searchDateEnd: e.target.value })}
                type="date"
                InputLabelProps={{ shrink: true }}
                disabled
                InputProps={{
                  style: { color: '#000000' }
                }}
              />
              <Button onClick={moveToNextFiscalYear} style={{ marginLeft: 8 }}>▶</Button>

              {/* <Typography variant="h6" style={{ fontWeight: 700, marginLeft: '16px' }}>　集計対象日：</Typography>
              <FormControl className={classes.formControl}>
                <Select
                  value={filter.invoiceDateType}
                  onChange={handleInvoiceDateTypeChange}
                  displayEmpty
                  className={classes.selectEmpty}
                >
                  <MenuItem value="0">排出日</MenuItem>
                  <MenuItem value="1">作成日</MenuItem>
                  <MenuItem value="2">中間処理日</MenuItem>
                  <MenuItem value="3">最終処分日</MenuItem>
                </Select>
              </FormControl> */}
              {currentUser.traderKbn !== '1000000000' && (
                <>
                  <Typography variant="h6" style={{ fontWeight: 700 }}>　　　　排出業者：</Typography>
                  <TextField
                    id="exhaustName"
                    value={filter.exhaustName}
                    onChange={e => handleFilterChange({ ...filter, exhaustName: e.target.value })}
                    label=""
                    type="text"
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        startFilter();
                      }
                    }}
                  />
                </>
              )}
              <Button
                variant='contained'
                color='primary'
                onClick={startFilter}
                style={{ marginLeft: 24 }}
                disabled={!isFilterChanged}
              >
                データ表示
              </Button>
            </Grid>
          </Grid>

          <SpaceRow height={10} />
          {(currentUser.traderKbn === '1111111111' || currentUser.traderKbn === '0000000001') && (
            <div className={classes.container}>
              <Box sx={{ height: 412, width: '100%' }}>
                <DataGridPro
                  sx={styles.grid}
                  columns={summaryColumns}
                  rows={summaryData}
                  loading={isLoading}
                  density="compact"
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  showColumnRightBorder
                  showCellRightBorder
                  localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                  onRowClick={handleadminRowClick}
                />
              </Box>
            </div>
          )}

          {(currentUser.traderKbn === '1111111111' || currentUser.traderKbn === '0000000001') && <SpaceRow height={50} />}
          {currentUser.traderKbn !== '1000000000' && (
            <div className={classes.container}>
              <Box sx={{ height: 412, width: '100%' }}>
                <DataGridPro
                  sx={styles.grid}
                  columns={cols}
                  rows={dataList}
                  loading={isLoading}
                  density="compact"
                  components={{
                    Toolbar: CustomToolbar,
                  }}
                  showColumnRightBorder
                  showCellRightBorder
                  localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                  onRowClick={handleExhaustRowClick}
                />
              </Box>
            </div>
          )}
          {currentUser.traderKbn !== '1000000000' && (
            <Box 
              mt={2} 
              p={2} 
              border={1} 
              borderColor="grey.300" 
              borderRadius={4} 
              maxWidth="80%" 
              margin="auto"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Typography variant="h7" align="center">
                表示中データの合計
                　　
                マニフェスト発行件数: {calculateTotals().kensu}
                　　
                マニフェスト取消件数: {calculateTotals().torikesi}
                　　
                マニフェスト登録件数: {calculateTotals().touroku}
              </Typography>
            </Box>
          )}
          <SpaceRow height={10} />
          <WasteMonthlyGrid data={detailData} selectedExhaustName={selectedExhaustName} />
        </>
      )}
      <SpaceRow height={20} />
    </>
  );
};

const styles = {
  grid: {
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#65b2c6',
      color: '#fff',
    }
  },
  grid2: {
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#4169e1',
      color: '#fff',
    }
  },
  grid3: {
    // 列ヘッダに背景色を指定
    '.MuiDataGrid-columnHeaders': {
      backgroundColor: '#a52a2a',
      color: '#fff',
    }
  }
};

export default EmissionsCount;